import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import CreateRewards from './Create';
import RewardsList from './RewardsList';
import RewardDetails from './RewardDetails';

export default function Rewards(props) {
  const history = useHistory();

  const createNew = () => {
    history.push("/rewards/create");
  }
  const id = new URLSearchParams(window.location.search).get("id")


  if (window.location.pathname === '/rewards' && id) {
    return <RewardDetails id={id} />
  }

  if (window.location.pathname === '/rewards') {
    return <RewardsList createNew={createNew} />
  }



  if (window.location.pathname === '/rewards/create') {
    return <CreateRewards />
  }

  return <div></div>

}